module.exports = __webpack_public_path__ + "media/misetIllus.b43eb95c.mp4";